import { render } from "./FooterSmall.vue?vue&type=template&id=2cafb607"
import script from "./FooterSmall.vue?vue&type=script&lang=js"
export * from "./FooterSmall.vue?vue&type=script&lang=js"
script.render = render

export default script